
import AllRoutes from './Allroutes/Allroute';
import './App.css';

// import Navbar from './components/navbar/Navbar';

function App() {
  return (
    <div className="App">
   <AllRoutes/>
    </div>
  );
}

export default App;
